const CDN_URL = 'https://scoroassets.scoro.com/gfx';
const ILLUSTRATIONS = `${CDN_URL}/illustrations`;

export const Assets = {
	CDN_URL,
	DEFAULT_LOGO: `${CDN_URL}/scoro_logo.svg`,
	DEFAULT_LOGO_LIGHT: `${CDN_URL}/scoro_logo_s.svg`,
	DEFAULT_LOGO_LIGHT_GRAY: `${CDN_URL}/scoro_logo_s_gray.svg`,
	DOCUMENT_PDF_SKELETON: `${CDN_URL}/document_sharing/pdf-skeleton.svg`,

	INTEGRATIONS_LOGO_FOLDER: `${CDN_URL}/integrations_logos`,
	PROJECT_REPORTS_BUDGET_CHART_EMPTY_ILLUSTRATION: `${ILLUSTRATIONS}/project-reports-budget-chart-empty-illustration.svg`,
	PROJECT_REPORTS_BURN_UP_CHART_EMPTY_ILLUSTRATION: `${ILLUSTRATIONS}/project-reports-burn-up-chart-empty-illustration.svg`,
	REPORT_EMPTY_ILLUSTRATION: `${ILLUSTRATIONS}/img-contacts.svg`,
	PROJECT_REPORTS_QVSA_EMPTY_ILLUSTRATION: `${ILLUSTRATIONS}/project-reports-qvsa-empty-illustration.svg`,
	RESOURCE_PLANNING_PORTFOLIO_EMPTY_ILLUSTRATION: `${CDN_URL}/bookings_empty_state.svg`,
	BAMBOO_HR_LOGO: `${CDN_URL}/integrations_logos/bamboohr.svg`,
	GOOGLE_CALENDAR_LOGO: `${CDN_URL}/integrations_logos/google_calendar.svg`,
};
